module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nr"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "fixed flexrow"
  }, [_c('div', {
    staticClass: "toparea-mic inner"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInput),
      expression: "showInput"
    }],
    staticClass: "flexcenter"
  }, [_c('div', {
    staticClass: "item bgdgray bdgreen w300",
    class: {
      textmgray: _vm.isTextGray
    }
  }, [_vm._v("\n            " + _vm._s(_vm.speakText) + "\n            "), _c('div', {
    staticClass: "mic-icon",
    class: _vm.scoreNum
  })]), _vm._v(" "), _c('button', {
    staticClass: "icon-skip",
    attrs: {
      "disabled": _vm.disableSkip
    },
    on: {
      "click": function($event) {
        return _vm.skipAct()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "inner",
    style: (_vm.nrStyles),
    attrs: {
      "id": "js-nr-acts"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, _vm._l((_vm.dispActBlockList), function(act, index) {
    return _c('div', {
      key: 'actKey' + index,
      staticClass: "flexbox"
    }, [_c('div', {
      staticClass: "thumb item",
      style: (_vm.getThumbPath(index, act.image))
    }), _vm._v(" "), _c('div', {
      staticClass: "item answer"
    }, [(_vm.isShowCorrectImg(index) || _vm.isShowIncorrectImg(index)) ? _c('div', {
      class: {
        correct: _vm.isShowCorrectImg(index),
        incorrect: _vm.isShowIncorrectImg(index)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "_item"
    }, [(_vm.runmode == _vm.mixinConstants.RUNMODE_NR3) ? [_c('p', {
      class: [_vm.isEnvironmentPc() ? _vm.getNRFontSize(act) : '', {
        active: _vm.isActActive(index)
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.getLangText(act)))
      }
    })])] : [(_vm.showAnswerLabelNR3(index)) ? _c('p', {
      class: [_vm.isEnvironmentPc() ? _vm.getNRFontSize(act) : '', {
        active: _vm.isActActive(index)
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.getLangText(act)))
      }
    })]) : _vm._e(), _vm._v(" "), (!_vm.showAnswerLabelNR3(index)) ? _c('div', {
      staticClass: "q-blank"
    }, [_c('p', {
      class: _vm.isEnvironmentPc() ? _vm.getNRFontSize(act) : ''
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.getQuestionBlankText(act)))
      }
    })])]) : _vm._e()], _vm._v(" "), _c('button', {
      staticClass: "icon-voice",
      attrs: {
        "disabled": _vm.disableReplayButton(index)
      },
      on: {
        "click": function($event) {
          return _vm.audioReplay(act.sounds[0])
        }
      }
    })], 2)])])
  }), 0)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ccf7976", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-2ccf7976","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/NR3.vue
// module id = 613
// module chunks = 1